import { useEffect, useState, useContext } from "react";
import { UserContext } from "../UserContext";
import { toast } from "react-toastify";
import PackDetails from "../PackDetails";

const ChangePlanModal = ({ visible, onClose, userId, type, currentPlanId, slot, token, onSuccess,
  allowedPlans,
  fetchComboOptions }) => {

  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!visible) return;

    const fetchPlans = async () => {
      setLoading(true);
      try {
        const response = await fetch(`https://vrplay.in/portal_php/customer/get_operator_plans.php?category=${type}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const data = await response.json();
        
        setPlans(data.plans || []);
      } catch (error) {
        console.error("Error fetching plans:", error);
        toast.error("Failed to load plans");
      } finally {
        setLoading(false);
      }
    };

    fetchPlans();
  }, [visible, type, token]);

  const handleSelect = async (plan) => {
    if (type === "ottplay" && slot === "1") {
      // fetchComboOptions({ ott1: plan.id });
    }

    if (type === "ottplay" && slot === "2") {
      // fetchComboOptions({ ott2: plan.id });
    }

    if (type === "watcho") {
      fetchComboOptions({ watcho: plan.id });
    }

    if (type === "playboxtv") {
      fetchComboOptions({ playboxtv: plan.id });
    }

    if (type === "antiptv" && slot === "1") {
      fetchComboOptions({ antiptv: plan.id });
    }


    if (!window.confirm("Change plan?")) return;

    setSubmitting(true);
    try {
      const res = await fetch(
        "https://vrplay.in/portal_php/customer/change_plan.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            user_id: userId,
            plan_id: plan.id,
            type,
            slot: slot
          })
        }
      );

      const data = await res.json();

      if (data.success) {
        toast.success("Plan updated");
        onSuccess();
        onClose();
      } else {
        toast.error(data.error);
      }
    } catch (error) {
      console.error("Error changing plan:", error);
      toast.error("Failed to change plan");
    } finally {
      setSubmitting(false);
    }
  };

  if (!visible) return null;

  const filteredPlans = plans.filter(plan => {

    if (type === "ottplay" && slot === "2") {
      return !allowedPlans?.ottplay2?.length || 
            allowedPlans.ottplay2.includes(plan.id);
    }

    if (type === "watcho") {
      return !allowedPlans?.watcho?.length || 
            allowedPlans.watcho.includes(plan.id);
    }

    if (type === "ottplay" && slot === "1") {
      return !allowedPlans?.ottplay1?.length || 
            allowedPlans.ottplay1.includes(plan.id);
    }

    return true;
  });

  return (
    <div className="modal-overlay">
      <div className="modal-content large">
        <h3>Select {type.toUpperCase()} Plan</h3>

        <div className="modal-body">
          {loading ? (
            <div className="loading-container">
              <div className="spinner"></div>
              <p>Loading plans...</p>
            </div>
          ) : (
            <div className="addon-grid">
              {plans.length === 0 ? (
                <div className="no-plans-message">
                  <p>No plans available</p>
                </div>
              ) : (
                
                filteredPlans.map(plan => {
                  const isCurrent = Number(plan.id) === Number(currentPlanId);

                  return (
                    <div
                      key={plan.id}
                      className={`plan-card ${isCurrent ? "current-plan" : ""} ${submitting ? "disabled" : ""}`}
                      onClick={() => !isCurrent && !submitting && handleSelect(plan)}
                      style={submitting && !isCurrent ? { cursor: "not-allowed", opacity: 0.6 } : {}}
                    >
                      {isCurrent && <div className="current-badge">CURRENT</div>}
                      <PackDetails {...plan} />
                    </div>
                  );
                })
              )}
            </div>
          )}
        </div>

        <button 
          className="btn btn-close" 
          onClick={onClose}
          disabled={submitting}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default ChangePlanModal;